var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleViewGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.75V11.25C2.25 10.425 2.925 9.75 3.75 9.75H14.25C15.075 9.75 15.75 10.425 15.75 11.25V12.75C15.75 13.575 15.075 14.25 14.25 14.25H3.75C2.925 14.25 2.25 13.575 2.25 12.75ZM2.25 5.25V6.75C2.25 7.575 2.925 8.25 3.75 8.25H14.25C15.075 8.25 15.75 7.575 15.75 6.75V5.25C15.75 4.425 15.075 3.75 14.25 3.75H3.75C2.925 3.75 2.25 4.425 2.25 5.25Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleViewGrid);
export default __webpack_public_path__ + "static/media/single-view-grid.4a0bde5f886b88f4bfcbbd9c72220c9c.svg";
export { ForwardRef as ReactComponent };